import React, { useContext, useEffect, useState } from "react";
import { ApplicationContext } from "@context/ApplicationContext";
import { AuthContext } from "@context/AuthContext";
import AlertMessage from "@components/AlertMessage";
import LetsGetStartedContent from "@components/LetsGetStartedContent";
import LogoBar from "@components/LogoBar";
import Button from "@components/Ui/Button";
import Spinner from "@components/Ui/Spinner";
import TextInput from "@components/Ui/TextInput";
import "./style.scss";

const LetsGetStarted = () => {

    const { whiteLabel } = useContext(ApplicationContext);
    const addDisplayName = whiteLabel?.subscriber_group?.add_display_name === true;
    const [username, setUsername] = useState("");
    const [otpCode, setOtpCode] = useState("");

    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");

    const {
        addAccountMemberId,
        verifyOtp,
        isLoginSubmitting,
        letsStartLoginError,
        setSuccessMessage,
        userAuth,
    } = useContext(AuthContext);

    useEffect(() => {
        return () => {
            setSuccessMessage(null);
        };
    }, []);


    const handleSubmit = (evt) => {
        evt.preventDefault();
        setSuccessMessage(null);
        const data = {
            email_address: username,
        };

        if (firstName && firstName.trim() !== "") {
            data.first_name = firstName.trim();
        }

        if (lastName && lastName.trim() !== "") {
            data.last_name = lastName.trim();
        }
        addAccountMemberId(data);
    };

    const handleFirstNameOnchange = (e) => {
        setFirstName(e.target.value);
    };

    const handleLastNameOnchange = (e) => {
        setLastName(e.target.value);
    };

    const handleUsernameOnchange = (e) => {
        setUsername(e.target.value);
    };

    const handleOtpOnchange = (e) => {
        setOtpCode(e.target.value);
    };

    const handleOtpSubmit = (evt) => {
        evt.preventDefault();
        setSuccessMessage(null);
        verifyOtp(otpCode);
    };

    const getStarted = whiteLabel?.subscriber_group?.subscriber_group_get_started;


    const titleStyle = getStarted?.page_title_color
        ? { color: getStarted.page_title_color }
        : undefined;

    const subtitleStyle = getStarted?.page_subtitle_color
        ? { color: getStarted.page_subtitle_color }
        : undefined;

    const whereToMessageStyle = getStarted?.where_to_message_color
        ? { color: getStarted.where_to_message_color }
        : undefined;

    return (
        <div className="lets-get-started__wrapper">
            <div className="container">
                <LogoBar />
            </div>
            <div className="container">
                <div className="lets-get-started__container">
                    <div className="lets-get-started__intro-wrapper">
                        {(getStarted?.page_title?.trim() || getStarted?.page_subtitle?.trim()) && (
                        <div className="lets-get-started__intro">
                            {getStarted?.page_title?.trim() && (
                                <h1
                                    className="lets-get-started__main-title"
                                    style={titleStyle}
                                >
                                    {getStarted.page_title.trim()}
                                </h1>
                            )}

                            {getStarted?.page_subtitle?.trim() && (
                                <p
                                    className="lets-get-started__text"
                                    style={subtitleStyle}
                                >
                                    {getStarted.page_subtitle.trim()}
                                </p>
                            )}
                        </div>
                    )}
                        <div className="lets-get-started__form-wrapper">
                            {!userAuth?.requireOtp ? (
                                <>
                                    <p
                                        className="lets-get-started__form-title"
                                        style={whereToMessageStyle}
                                >
                                        {getStarted?.where_to_message ?? "Where would you like us to send your purchase?"}
                                    </p>
                                    {!addDisplayName ? (
                                        <form onSubmit={handleSubmit} className="lets-get-started__form-outer">
                                            <div className="lets-get-started__form">
                                                <TextInput
                                                    type="email"
                                                    name="username"
                                                    placeholder="Enter email address"
                                                    additionalClasses={`lets-get-started__input lets-get-started__input--wide ${
                                                            letsStartLoginError ? "lets-get-started__input--error" : ""
                                                        } `}
                                                    required={true}
                                                    value={username}
                                                    onChange={handleUsernameOnchange}
                                                    />
                                                <Button additionalClasses="button button__primary lets-get-started__button">
                                                    {isLoginSubmitting ? <Spinner text="loading..." /> : <span>Get Started</span>}
                                                </Button>
                                            </div>
                                        </form>

                                    ) : (
                                        <form onSubmit={handleSubmit} className="lets-get-started__form-outer">

                                            <div className="lets-get-started__form-inner">
                                                <TextInput
                                                    id="first_name"
                                                    additionalClasses="lets-get-started__input lets-get-started__input--small"
                                                    name="first_name"
                                                    placeholder="First Name"
                                                    value={firstName}
                                                    onChange={handleFirstNameOnchange}
                                                />
                                                <TextInput
                                                    id="last_name"
                                                    additionalClasses="lets-get-started__input lets-get-started__input--small"
                                                    name="last_name"
                                                    placeholder="Last Name"
                                                    value={lastName}
                                                    onChange={handleLastNameOnchange}
                                                />
                                            </div>

                                            <div className="lets-get-started__form">
                                                <TextInput
                                                    type="email"
                                                    name="username"
                                                    placeholder="Enter email address"
                                                    additionalClasses={`lets-get-started__input lets-get-started__input--wide ${
                                                        letsStartLoginError ? "lets-get-started__input--error" : ""
                                                    } `}
                                                    required={true}
                                                    value={username}
                                                    onChange={handleUsernameOnchange}
                                                />
                                                <Button additionalClasses="button button__primary lets-get-started__button">
                                                    {isLoginSubmitting ? <Spinner text="loading..." /> : <span>Get Started</span>}
                                                </Button>
                                            </div>
                                        </form>
                                    ) }

                                </>
                        ) : (
                            <>
                                <p className="lets-get-started__form-title" style={whereToMessageStyle}>
                                    Enter the verification code sent to your email
                                </p>
                                <form onSubmit={handleOtpSubmit} className="lets-get-started__form">
                                    <TextInput
                                        type="text"
                                        name="otpCode"
                                        placeholder="Enter verification code"
                                        additionalClasses={`lets-get-started__input ${
                                            letsStartLoginError ? "lets-get-started__input--error" : ""
                                        } `}
                                        required={true}
                                        value={otpCode}
                                        onChange={handleOtpOnchange}
                                    />
                                    <Button additionalClasses="button button__primary lets-get-started__button">
                                        {isLoginSubmitting ? <Spinner text="loading..." /> : <span>Verify</span>}
                                    </Button>
                                </form>
                            </>
                        )}

                            {letsStartLoginError && <AlertMessage message={letsStartLoginError} additionalClass="centre" type="error" />}
                        </div>
                    </div>
                    <div className="lets-get-started__inner">
                        <LetsGetStartedContent />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LetsGetStarted;
